import React, { Component, Suspense, lazy } from "react";
import { Menu, Icon, Sidebar, Button } from "semantic-ui-react";
import "../../Courses/stylesheets/headerStyles.css";
import { withRouter } from "react-router-dom";
import Notification from "./Notification";
import axios from "../../axios";
import Profile from "./Profile";
import { clearStore, setUserData } from "./LoginModalSlice";
import { connect } from "react-redux";
import SearchModal from "./SearchModal";
import headerScripts from "./headerScripts";
import BackToTop from "../BackToTop";
import $ from "jquery";
// import lottie from "lottie-web";
import HeaderMenuItems from "./menuItem";
import { SALE_ACTIVE, ONE_TAP_URL, GOOGLE_CLIENT_ID } from "../../urls";
import CountdownTimer from "./CountdownTimer";
import DarkModeIcon from "./DarkModeIcon";

class Layout extends Component {
  timerInterval = React.createRef();
  saleRef = React.createRef();
  headerAnimationRef = React.createRef();
  state = {
    visible: false,
    userDataLoader: false,
    showLoginModal: false,
    isLoading: false,
    profileUrl: null,
    showNotification: false,
    isProfileVisible: false,
    currentDate: new Date(),
    hideTimer: true,
  };

  closeModal = () => {
    this.setState({ showLoginModal: false });
    this.props.onCloseModal();
  };

  renderSignInBtn() {
    return (
      <Button
        id="singInBtn"
        onClick={() => {
          this.setState({ showLoginModal: true, visible: false });
        }}
      >
        Sign In
      </Button>
    );
  }

  logoHandler = () => {
    return (
      <a id="header_logo" className="item header-main__logo" href="/home">
        {
          <svg
            id="header_logo"
            xmlns="http://www.w3.org/2000/svg"
            width="76.533"
            height="39.026"
            viewBox="0 0 76.533 39.026"
          >
            <path
              d="M2380.7,6597.866a12.252,12.252,0,0,0-.261-1.513l-30.726-.027a12.545,12.545,0,0,1,.908-3.443,12.337,12.337,0,0,1,2.739-4.044,12.151,12.151,0,0,1,4.018-2.581,12.634,12.634,0,0,1,14.3,3.051l4.852-4.748a18.176,18.176,0,0,0-6.131-4.331,20.037,20.037,0,0,0-8.112-1.564,20.25,20.25,0,0,0-7.671,1.459,19.158,19.158,0,0,0-6.261,4.07,19.584,19.584,0,0,0-4.226,6.184,18.7,18.7,0,0,0-1.487,5.947h-.2a18.674,18.674,0,0,0-1.489-5.947,19.544,19.544,0,0,0-4.226-6.184,19.133,19.133,0,0,0-6.261-4.07,21.354,21.354,0,0,0-15.783.1,18.2,18.2,0,0,0-6.131,4.331l4.853,4.748a13.264,13.264,0,0,1,14.3-3.051,12.131,12.131,0,0,1,4.017,2.581,12.323,12.323,0,0,1,2.74,4.044,12.527,12.527,0,0,1,.908,3.443l-30.726.027a12.256,12.256,0,0,0-.261,1.513,15,15,0,0,0-.1,1.773,20.713,20.713,0,0,0,1.1,6.783,15.709,15.709,0,0,0,3.443,5.686,17.309,17.309,0,0,0,6,4.123,20.587,20.587,0,0,0,7.983,1.46,20.226,20.226,0,0,0,7.669-1.46,19.086,19.086,0,0,0,6.261-4.07,19.506,19.506,0,0,0,4.226-6.184,18.163,18.163,0,0,0,1.153-3.629h.871a18.27,18.27,0,0,0,1.151,3.629,19.545,19.545,0,0,0,4.226,6.184,19.111,19.111,0,0,0,6.261,4.07,20.241,20.241,0,0,0,7.671,1.46,20.572,20.572,0,0,0,7.981-1.46,17.282,17.282,0,0,0,6-4.123,15.717,15.717,0,0,0,3.445-5.686,20.726,20.726,0,0,0,1.1-6.783A15.259,15.259,0,0,0,2380.7,6597.866Zm-46.245,5.608a12.1,12.1,0,0,1-2.766,4.043,12.467,12.467,0,0,1-4.043,2.583,14.378,14.378,0,0,1-9.939.052,11.776,11.776,0,0,1-3.522-2.218,8.459,8.459,0,0,1-1.8-2.374,13.476,13.476,0,0,1-1.173-3.208l23.658,0A11.487,11.487,0,0,1,2334.457,6603.475Zm38.236,2.086a8.466,8.466,0,0,1-1.8,2.374,11.771,11.771,0,0,1-3.522,2.218,14.378,14.378,0,0,1-9.939-.052,12.491,12.491,0,0,1-4.044-2.583,12.088,12.088,0,0,1-2.765-4.043,11.427,11.427,0,0,1-.415-1.126h11.92v0h11.739A13.509,13.509,0,0,1,2372.692,6605.561Z"
              transform="translate(-2304.273 -6578.666)"
              fill="#2f8d46"
            />
          </svg>
        }
      </a>
    );
  };

  appendScriptHelper = (scriptEl) => {
    const script = document.createElement(scriptEl.el);
    if (scriptEl.src) script.src = scriptEl.src;
    else {
      const scriptTextNode = document.createTextNode(scriptEl.textNode);
      script.appendChild(scriptTextNode);
    }
    document.head.appendChild(script);
  };

  componentDidMount = () => {
    $("body").on("click", ".loggedOutBtn , .login-modal-btn", function (e) {
      e.preventDefault();
      let signInButton = document.getElementById("singInBtn");
      if (signInButton) signInButton.click();
    });

    headerScripts.loadWithoutDelay.forEach((scriptEl) => {
      this.appendScriptHelper(scriptEl);
    });

    headerScripts.loadWithDelay.forEach((scriptEl) => {
      setTimeout(() => {
        if (!scriptEl?.url || window.location.href.includes(scriptEl.url)) {
          this.appendScriptHelper(scriptEl);
        }
      }, 2000);
    });

    this.setState({
      userDataLoader: true,
    });
    axios
      .get(`users/getProfile`)
      .then((response) => {
        this.setState({ profileUrl: response.data.data.profile_url });
        if (
          response.data &&
          Object.keys(response.data).length > 0 &&
          response.data.data
        )
          this.props.onLoad(response.data.data);
        this.setState({
          currentDate: response?.headers?.["x-date"],
          userDataLoader: false,
        });
      })
      .catch((error) => {
        const script = document.createElement("script");
        script.src = "https://accounts.google.com/gsi/client";
        document.head.appendChild(script);
        this.setState({
          userDataLoader: false,
        });
      });

    // if (this.saleRef) {
    //   lottie.destroy("Green Icon Animation");
    //   lottie.loadAnimation({
    //     container: this.saleRef.current,
    //     renderer: "svg",
    //     loop: true,
    //     autoplay: true,
    //     name: "",
    //     animationData: GENERAL_ANIMATIONS.sale,
    //   });
    // }

    let url = window.location.href;
    let urlDetails = url.split("/");
    if (
      urlDetails &&
      (urlDetails[3] === "courses" || urlDetails[3] === "payments")
    ) {
      this.setState({
        hideTimer: true,
      });
    }
  };

  logoutUrl() {
    window.open(
      `${process.env.REACT_APP_AUTH_URL}/logout.php?to=${window.location.href}`,
      "_self"
    );
  }

  renderNotificationBell = (customClass) => {
    return (
      <Menu.Item
        className={customClass}
        onClick={(event) => {
          event.stopPropagation();
          let showNotification = this.state.showNotification;
          this.setState({
            showNotification: !showNotification,
            isProfileVisible: false,
          });
        }}
      >
        <Icon name="bell outline" size="large" className="icon-notif" />
      </Menu.Item>
    );
  };

  renderSearchModal = (customClass) => {
    return <SearchModal customClass={customClass} />;
  };

  fetchBrowserInfo = () => {
    const browserInfo = {};
    browserInfo.appName = navigator.appName;
    browserInfo.appCodeName = navigator.appCodeName;
    browserInfo.cookieEnable = navigator.cookieEnabled;
    browserInfo.prodName = navigator.product;
    browserInfo.appVersion = navigator.appVersion;
    browserInfo.appOs = navigator.platform;
    browserInfo.appLang = navigator.language;
    browserInfo.vendorName = navigator.vendor;
    browserInfo.loginDomain = "auth";
    return browserInfo;
  };

  render() {
    let loginModal = null;
    const { showDarkModeButton } = this.props;
    if (this.state.showLoginModal) {
      const LoginModalDyn = lazy(() => import("./LoginModal"));
      loginModal = (
        <Suspense fallback={<div></div>}>
          <LoginModalDyn
            showModal={this.state.showLoginModal}
            closeModal={this.closeModal}
          />
        </Suspense>
      );
    }

    return (
      <div className="gfg-header">
        <div
          id="g_id_onload"
          data-client_id={GOOGLE_CLIENT_ID}
          data-state_cookie_domain="geeksforgeeks.org"
          data-login_uri={ONE_TAP_URL}
          data-redirect={window.location.href}
          data-browserInfo={JSON.stringify(this.fetchBrowserInfo())}
          data-cancel_on_tap_outside="false"
        />
        {loginModal}
        {this.state.showNotification && (
          <Notification
            onClose={() => {
              this.setState({
                showNotification: false,
              });
            }}
          />
        )}
        <Menu color="green" borderless fixed={"top"} className="header">
          <div className="headerLg">
            <div style={{ display: "flex" }}>
              {SALE_ACTIVE &&
                !this.state.hideTimer &&
                (Date.parse(this.state.currentDate) >=
                Date.parse("Sun Jan 08 2023 23:59:59") ? (
                  <CountdownTimer currentDate={this.state.currentDate} />
                ) : (
                  <a
                    href="/courses"
                    className="menu-item-header item header_animation"
                    ref={this.saleRef}
                  />
                ))}
              <HeaderMenuItems headerAnimationRef={this.headerAnimationRef} />
            </div>
            {this.logoHandler()}
            <Menu.Menu position="right">
              {showDarkModeButton && (
                <Menu.Item className="iconContainer open-tooltip">
                  <DarkModeIcon />
                </Menu.Item>
              )}
              <Menu.Item className="iconContainer">
                {this.renderSearchModal("search-modal")}
              </Menu.Item>
              {this.props.userData &&
                this.renderNotificationBell("iconContainer")}
              <Menu.Item className="iconContainer">
                {this.state.isProfileVisible && (
                  <Profile
                    userHandle={this.props.userData.handle}
                    onClose={() => {
                      this.setState({
                        isProfileVisible: false,
                      });
                    }}
                  />
                )}
                {this.state.userDataLoader ? (
                  <div style={{ width: "50px" }}> </div>
                ) : (
                  <React.Fragment>
                    {this.props.userData ? (
                      <img
                        src={this.state.profileUrl}
                        className="profile"
                        onClick={(event) => {
                          event.stopPropagation();
                          let isProfileVisible = this.state.isProfileVisible;
                          this.setState({
                            isProfileVisible: !isProfileVisible,
                            showNotification: false,
                          });
                        }}
                      />
                    ) : (
                      this.renderSignInBtn()
                    )}
                  </React.Fragment>
                )}
              </Menu.Item>
            </Menu.Menu>
          </div>
          <div className="headerSm">
            <Icon
              name={this.state.visible ? "close" : "bars"}
              size="big"
              color="black"
              className="menuIcon"
              onClick={() => {
                this.setState((prevState) => {
                  return {
                    visible: !prevState.visible,
                  };
                });
              }}
            />
            {this.logoHandler()}
            <Menu.Menu position="right">
              <Menu.Item className="search-icon">
                {this.renderSearchModal("search-modal-sm")}
              </Menu.Item>
              {this.props.userData && this.renderNotificationBell("icon-bell")}
            </Menu.Menu>
          </div>
        </Menu>
        <Sidebar
          as={Menu}
          animation="overlay"
          icon="labeled"
          onHide={() => this.setState({ visible: false })}
          vertical
          visible={this.state.visible}
          width="thin"
          className="sideMenu"
        >
          {this.props.userData ? (
            <React.Fragment>
              <Menu.Item className="profileImageCnt">
                {<img src={this.state.profileUrl} className="profileSm" />}
              </Menu.Item>
              <Menu.Item className="hamburger">
                <Menu.Item
                  onClick={() => {
                    window.open(
                      `${process.env.REACT_APP_AUTH_URL}/user/${this.props.userData.handle}/practice`,
                      "_self"
                    );
                  }}
                >
                  <Icon name="user" /> My Profile
                </Menu.Item>
                <Menu.Item onClick={this.logoutUrl}>
                  <Icon name="sign-out" /> Logout
                </Menu.Item>
                {showDarkModeButton && (
                  <Menu.Item>
                    <div className="dark_mode_phone">{<DarkModeIcon />}</div>
                  </Menu.Item>
                )}
              </Menu.Item>
              <Menu.Item href="/myCourses" target="_self">
                <Icon name="book" /> My Courses
              </Menu.Item>
              <Menu.Item href="/transactions" target="_self">
                <Icon name="redo" /> My Transactions
              </Menu.Item>
            </React.Fragment>
          ) : (
            <Menu.Item textAlign="center">{this.renderSignInBtn()}</Menu.Item>
          )}
          <HeaderMenuItems />
        </Sidebar>
        <BackToTop></BackToTop>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userData: state.userData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    onCloseModal: () => {
      dispatch(clearStore());
    },
    onLoad: (data) => {
      dispatch(setUserData(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Layout));
